import {CALL_API} from '../../middleware/api';

// 查询员工或部门
export const ORGANIZATION_USER_GLOBAL_INQUIRE_REQUEST = 'ORGANIZATION_USER_GLOBAL_INQUIRE_REQUEST';
export const ORGANIZATION_USER_GLOBAL_INQUIRE_SUCCESS = 'ORGANIZATION_USER_GLOBAL_INQUIRE_SUCCESS';
export const ORGANIZATION_USER_GLOBAL_INQUIRE_FAILURE = 'ORGANIZATION_USER_GLOBAL_INQUIRE_FAILURE';

export function globalInquire(param) {
	return {
		[CALL_API]: {
			types: [ORGANIZATION_USER_GLOBAL_INQUIRE_REQUEST, ORGANIZATION_USER_GLOBAL_INQUIRE_SUCCESS, ORGANIZATION_USER_GLOBAL_INQUIRE_FAILURE],
			endpoint: `/organization/user/global-inquire`,
			params: {param},
			methods: 'POST'
		}
	}
}


export default (params) => {
	return (dispatch, getState) => {
		return dispatch(globalInquire(params));
	};
};


// WEBPACK FOOTER //
// ./src/action/organization/globalInquire.js